import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ChangePasswordPopupComponent } from './change-password-popup.component';

@NgModule({
  declarations: [ChangePasswordPopupComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  exports: [ChangePasswordPopupComponent],
})
export class ChangePasswordPopupModule {}
